// src/app/views/pages_predict/leet/rtPrLeet.js
import Loadable from "app/components/Loadable";
import { lazy } from "react";
import { getPathByCdExt } from "app/utils/utils";
import { EXAM_TYPES } from "app/types/examTypes";

// Store the exam code extension to avoid redundancy
const examCodeExt = EXAM_TYPES.LEET.rid_cd_ext;

const LeetVerify = Loadable(lazy(() => import("./LeetVerify")));
const LeetMark = Loadable(lazy(() => import("./LeetMark")));
const LeetSurvey = Loadable(lazy(() => import("./LeetSurvey")));
const LeetResult = Loadable(lazy(() => import("./LeetResult")));
// const LeetScore = Loadable(lazy(() => import("./LeetScore")));

const rtPrLeet = [
  { path: `/pre/${EXAM_TYPES.LEET.rid_cd_ext}/verify`, element: <LeetVerify /> },
  { path: `/pre/${EXAM_TYPES.LEET.rid_cd_ext}/mark`, element: <LeetMark /> },
  { path: `/pre/${EXAM_TYPES.LEET.rid_cd_ext}/survey`, element: <LeetSurvey /> },
  { path: `/pre/${EXAM_TYPES.LEET.rid_cd_ext}/result`, element: <LeetResult /> },
];
export default rtPrLeet;
